export default __webpack_public_path__ + "static/media/enviro-background.0e63697d.jpg";